import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrFQuarter = createSelector([selectQbrState], ({ fQuarter }) => fQuarter)
